import { createContext, useContext, type ReactNode } from 'react';

import { DEFAULT_ACCESSIBILITY_PREFERENCES } from '@/lib/accessibility/types';
import type { AccessibilityPreferences } from '@/lib/accessibility/types';

// Editor-only, ephemeral preview state (spec §10.2) — never persisted,
// never touches theme_config. Consumed by PreviewCard so every Site
// Styles screen's existing preview picks it up automatically without each
// screen needing to thread it through as a prop.
const AccessibilityPreviewContext = createContext<AccessibilityPreferences>(DEFAULT_ACCESSIBILITY_PREFERENCES);

export function AccessibilityPreviewProvider({
  preferences,
  children,
}: {
  preferences: AccessibilityPreferences;
  children: ReactNode;
}) {
  return <AccessibilityPreviewContext.Provider value={preferences}>{children}</AccessibilityPreviewContext.Provider>;
}

export function useAccessibilityPreviewPreferences(): AccessibilityPreferences {
  return useContext(AccessibilityPreviewContext);
}
